import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_DefaultPanel } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingDefaultPanel, getActivePeriods } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import AddDefaultPanel from "./AddDefaultPanel";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";

export default function DefaultPanel() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const {
    accountingDefaultPanel,
    activePeriods,
    getDefaultPanelAgain,
    pagination,
  } = useSelector((state) => ({
    accountingDefaultPanel: state.saAccounts.accountingDefaultPanel,
    activePeriods: state.saAccounts.activePeriods,
    getDefaultPanelAgain: state.saAccounts.getDefaultPanelAgain,
    pagination: state.saAccounts.pagination,
  }));

  const [columns, setColumns] = useState([]);
  const [controls, setControls] = useSetState({
    periods: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...satc_DefaultPanel];
    _columns[6].hidden = !read("FormDefaultPanel").accessUpdate;
    _columns[7].hidden = !read("FormDefaultPanel").accessDelete;
    setColumns(_columns);
    await getPeriods();
    await getDefaltPanel(1, sizePerPage);
  };

  const getDefaltPanel = async (_page, _sizePerPage, dataSearch = null) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
        ...dataSearch,
      };
      await dispatch(getAccountingDefaultPanel(params));
      setLoading(false);
      resolve(true);
    });
  };

  const getPeriods = async () => {
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      };
      await dispatch(getActivePeriods(params));
      resolve(true);
    });
  };

  useEffect(() => {
    if (accountingDefaultPanel) {
      setTblData(accountingDefaultPanel);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountingDefaultPanel]);

  useEffect(() => {
    if (activePeriods) {
      const defArr = [{ label: t("chooseOnePeriod"), value: -1 }];
      const selectItems = activePeriods.map((child) => {
        return {
          label: child.Name,
          value: child.Id,
        };
      });
      setControls({ periods: { selectItems: defArr.concat(selectItems) } });
      setControls({ periods: { value: defArr[0] } });
    }
  }, [activePeriods]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await tblRefresh(page, sizePerPage);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    await tblRefresh(1, sizePerPage, value.value);
  };

  useEffect(() => {
    if (getDefaultPanelAgain) {
      (async () => {
        await tblRefresh(currentPage, sizePerPage);
      })();
    }
  }, [getDefaultPanelAgain]);

  const tblRefresh = async (innerPage, innerSizePerPage, period = null) => {
    let dataSearch = {}; //periodId
    const { periods } = controls;
    if (period) {
      if (period !== -1) {
        dataSearch.PeriodId = period;
      }
    } else if (periods.value.value !== -1) {
      dataSearch.PeriodId = periods.value.value;
    }
    await getDefaltPanel(innerPage, innerSizePerPage, dataSearch);
  };

  return (
    <>
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id="defaultPanel" />} />
        <div className="top-buttons">
          <AddDefaultPanel disabled={loading} />
        </div>
      </div>
      <BackDropLoading loading={loading} />
      <MuiPaper className="pt-2 mb-5">
        <Grid container spacing={2} className="mb-2">
          <Grid item md={3} sm={6} xs={12}>
            {!loading ? (
              <MuiAutoComplete
                autoSelect={true}
                options={controls.periods.selectItems}
                label={<Translator id="periods" />}
                value={controls.periods.value}
                onChange={autoCompleteHandler}
                id={"periods"}
              />
            ) : (
              <Skeleton variant="text" className="p-2" animation="wave" />
            )}
          </Grid>
        </Grid>
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
